import {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';
import Fetcher from '../shared/fetches/fetcher';
import {fetchStudentData} from '../../redux/actions/student';
import Profile from './profile';
import UpdatePasswordForm from './update-password-form';
import {Grid, Menu} from 'semantic-ui-react';
import UpdateMobile from './update-mobile';
import MobileVerification from './mobile-verification';
import UpdateUserDataForm from './update-user-form';
import UpdateStudentTypeContainer from './update-student-type/container';

function ProfileContainer(props) {
  const {match: {params: {item}}} = props;
  const [activeItem, setActiveItem] = useState(getMatchedItem(item));

  useEffect(function () {
    setActiveItem(getMatchedItem((item)));
  }, [item]);

  return (
    <Fetcher
      action={fetchStudentData}
      stateSelector={state => state.student}
    >
      {student => (
        <Grid stackable>
          <Grid.Column width={4}>
            <Menu fluid vertical stackable>
              <Menu.Item
                name='مشخصات'
                active={activeItem === BIO}
                onClick={updateRoute.bind(null, props.history.push, 'bio')}
              />
              <Menu.Item
                name='تغییر اطلاعات کاربر'
                active={activeItem === UPDATE_USER_DATA}
                onClick={updateRoute.bind(null, props.history.push, 'update-user-data')}
              />
              <Menu.Item
                name='تغییر رمز عبور'
                active={activeItem === UPDATE_PASSWORD}
                onClick={updateRoute.bind(null, props.history.push, 'update-password')}
              />
              {student.user && !student.user.mobileVerified && (
                <Menu.Item
                  name='تایید شماره تلفن همراه'
                  active={activeItem === MOBILE_VERIFICATION}
                  onClick={updateRoute.bind(null, props.history.push, 'mobile-verification')}
                />
              )}
              <Menu.Item
                name='تغییر شماره تلفن همراه'
                active={activeItem === UPDATE_MOBILE}
                onClick={updateRoute.bind(null, props.history.push, 'update-mobile')}
              />
              <Menu.Item
                name='تغییر دوره'
                active={activeItem === UPDATE_STUDENT_TYPE}
                onClick={updateRoute.bind(null, props.history.push, 'update-student-type')}
              />
            </Menu>
          </Grid.Column>

          <Grid.Column stretched width={12}>
            {(activeItem === BIO) ? (
              <Profile student={student}/>
            ) : (activeItem === UPDATE_USER_DATA) ? (
              <UpdateUserDataForm/>
            ) : (activeItem === UPDATE_PASSWORD) ? (
              <UpdatePasswordForm/>
            ) : (activeItem === MOBILE_VERIFICATION) ? (
              <MobileVerification onSuccess={setActiveItem.bind(null, BIO)}/>
            ) : (activeItem === UPDATE_MOBILE) ? (
              <UpdateMobile/>
            ) : (activeItem === UPDATE_STUDENT_TYPE) ? (
              <UpdateStudentTypeContainer studentTypeId={props.studentType}/>
            ) : null}
          </Grid.Column>
        </Grid>
      )}
    </Fetcher>
  );
}

function updateRoute(push, item) {
  push(`/profile/${item}`);
}

const [BIO, UPDATE_USER_DATA, UPDATE_PASSWORD, MOBILE_VERIFICATION, UPDATE_MOBILE, UPDATE_STUDENT_TYPE] = [0, 1, 2, 3, 4, 5];

function getMatchedItem(item) {
  switch (item) {
    case 'bio':
      return BIO;
    case 'update-password':
      return UPDATE_PASSWORD;
    case 'update-user-data':
      return UPDATE_USER_DATA;
    case 'mobile-verification':
      return MOBILE_VERIFICATION;
    case 'update-mobile':
      return UPDATE_MOBILE;
    case 'update-student-type':
      return UPDATE_STUDENT_TYPE;
    default:
      return BIO;
  }
}

export default withRouter(ProfileContainer);
